import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { Store } from '@ngrx/store';

import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { AlertComponent, DisplayInputComponent } from '@components';
import { Transaction } from '@models';
import {
  fetchCurrentTransactionById,
  selectCurrentTransaction,
  selectTransactionFetchedAt,
} from '@state';
import { PaymentUtils } from '@utils';

@Component({
  selector: 'app-transaction',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    DisplayInputComponent,
    AlertComponent,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './transaction.page.html',
  styleUrl: './transaction.page.scss',
})
export class TransactionPage implements OnInit {
  public $transaction = this.store.select(selectCurrentTransaction);
  public $transactionFetchedAt = this.store.select(selectTransactionFetchedAt);

  public loading: boolean = false;
  public error: string | null = null;

  public columns: string[] = [
    // 'id',
    'userId',
    'statementId',
    'amount',
    'status',
  ];

  constructor(private store: Store, private router: Router) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchCurrentTransactionById());
  }

  public isPaid(transaction: Transaction): boolean {
    return PaymentUtils.isPaid(transaction.status);
  }

  public getStatusText(transaction: Transaction): string {
    return PaymentUtils.getStatusText(transaction.status);
  }

  public navToPaymentDetails(paymentId: string): void {
    this.router.navigate(['/payments', paymentId]);
  }

  public navToUserDetails(userId: string): void {
    this.router.navigate(['/users', userId]);
  }

  public navToStatementDetails(userId: string, statementId: string): void {
    this.router.navigate(['/users', userId], {
      queryParams: { tab: 'statements', statementId },
    });
  }
}
